import { render, staticRenderFns } from "./ClaimTK.vue?vue&type=template&id=408d4d08&scoped=true"
import script from "./ClaimTK.vue?vue&type=script&lang=js"
export * from "./ClaimTK.vue?vue&type=script&lang=js"
import style0 from "./ClaimTK.vue?vue&type=style&index=0&id=408d4d08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d4d08",
  null
  
)

export default component.exports